import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { EducationAndQualificationList } from '@/routes/_staff/person/$id/_profile/education-and-qualification/-components/EducationAndQualificationList';
import { EducationAndQualificationSearchSchema } from '@/routes/_staff/person/$id/_profile/education-and-qualification/certification/-zod-schema';
const from = '/_staff/person/alumni/$id/_profile/education-and-qualification/';
const path = '/person/alumni/$id/education-and-qualification';
export const Route = createFileRoute(from)({
  component: RouteComponent,
  validateSearch: zodValidator(EducationAndQualificationSearchSchema)
});
function RouteComponent() {
  return <EducationAndQualificationList from={from} path={path} />;
}